var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',{staticClass:"layout-gallery"},[_c('el-container',[_c('layout-gallery-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }